import { HStack, Text, VStack } from "@chakra-ui/react";
import { UserFragment } from "gql/graphql";
import { OutOfOfficeIcon } from "modules/icons";
import moment from "moment";
import React, { memo, useMemo } from "react";
import colors from "app/colors";
import {
  getOutOfOfficeDisplayType,
  isUserOutOfOffice,
} from "modules/utils/Functions";
import { OOO_TIME_FORMAT } from "modules/utils/Constants";

interface IProps {
  user: UserFragment;
}

const UserOutOfOfficeInfo = ({ user }: IProps) => {
  const outOfOffice = user.outOfOffice;

  const displayType = useMemo(
    () => getOutOfOfficeDisplayType(outOfOffice),
    [outOfOffice],
  );

  if (!outOfOffice || !isUserOutOfOffice(user)) return null;

  return (
    <HStack
      p={2}
      bg={colors.yellow20}
      borderRadius={4}
      w="full"
      alignItems="flex-start"
    >
      <OutOfOfficeIcon fill={colors.yellowDark} boxSize={6} />
      <VStack spacing={0} w="full" alignItems="flex-start">
        {displayType === "single-day" && (
          <Text fontSize={14} fontWeight={400} color={colors.blackSecondary}>
            Away on{" "}
            <Text fontWeight={700} as="span">
              {moment(outOfOffice.startTime).format(OOO_TIME_FORMAT)}
            </Text>
          </Text>
        )}
        {displayType === "no-last-day" && (
          <Text fontSize={14} fontWeight={400} color={colors.blackSecondary}>
            Away beginning{" "}
            <Text fontWeight={700} as="span">
              {moment(outOfOffice.startTime).format(OOO_TIME_FORMAT)}
            </Text>
          </Text>
        )}
        {displayType === "default" && (
          <Text fontSize={14} fontWeight={400} color={colors.blackSecondary}>
            Away{" "}
            <Text fontWeight={700} as="span">
              {`${moment(outOfOffice.startTime).format(OOO_TIME_FORMAT)} - ${moment(outOfOffice.endTime).format(OOO_TIME_FORMAT)}`}
            </Text>
          </Text>
        )}
        {!!outOfOffice.message && (
          <Text fontSize={14} fontWeight={400}>
            “{outOfOffice.message}”
          </Text>
        )}
      </VStack>
    </HStack>
  );
};

export default memo(UserOutOfOfficeInfo);
